import { Loader } from '@/components/Loader/Loader'
import { Dropdown } from '@/components/Select/Dropdown'
import GitBranchSvg from '@/icons/git-branch.svg?react'
import { useBranchesState } from '@/state/branches'
import { useRepoListState } from '@/state/repoList'
import type { FunctionalComponent } from 'preact'
import { useMemo } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

export const Branch: FunctionalComponent<{
  repoId: number
  owner: string
  repo: string
}> = props => {
  const fetchBranches = useBranchesState(s => s.fetch)
  const setSelected = useBranchesState(s => s.setSelected)
  const defaultBranch = useRepoListState(s =>
    s.list.find(repo => repo.id === props.repoId)?.default_branch
  )

  const repoFullName = useMemo(() => `${props.owner}/${props.repo}`, [props.owner, props.repo])

  const selected = useBranchesState(s => (
    defaultBranch ? s.getSelected(repoFullName, defaultBranch) : null
  ))

  const branches = useBranchesState(useShallow(s => (
    (s.branches[repoFullName] ?? []).map(item => item.name)
  )))

  return (
    <Dropdown
      width={200}
      placement='bottom-end'
      onChange={branch => {
        if (!defaultBranch) return
        setSelected(repoFullName, branch ?? defaultBranch)
      }}
      value={selected}
      options={branches.length > 0
        ? branches.map(branch => ({
          value: branch,
          label: branch,
        }))
        : [{
          value: '',
          label: (
            <>
              Loading <Loader />
            </>
          ),
          disabled: true,
        }]}
    >
      {({ setRef, triggerProps }) => (
        <button
          {...triggerProps({
            onClick: () => {
              fetchBranches(props.owner, props.repo)
            },
          })}
          ref={setRef}
          class={styles.root}
        >
          <div class={styles.inner}>
            <GitBranchSvg class={styles.icon} />
            <span class={styles.name}>
              {selected}
            </span>
          </div>
        </button>
      )}
    </Dropdown>
  )
}
